import {
    RadioGroup,
    Stack,
    Radio,
    Text,
    Flex,
    Box,
    Image,
    useDisclosure,
    Divider,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ResponseModal } from "./responseModals";
import { ConfirmeModal } from "./responseModals/ConfirmeModal";
import { useRefund } from "@/hooks/useRefundPartial";
import { Button, Modal } from "barte-design-system";
import { InputCurrency } from "@/components";
export const RefundModal = ({ setReload, isDisabled, charge, responseVerify: responseVerifyProp, onRefundSuccess, isOpen: externalIsOpen, onClose: externalOnClose }: {setReload: React.Dispatch<React.SetStateAction<number>> , isDisabled: boolean, charge : any, responseVerify : any, onRefundSuccess?: (id: string) => Promise<void>, isOpen?: boolean, onClose?: () => void } ) => {
    const disclosure = useDisclosure();
    const isOpen = externalIsOpen ?? disclosure.isOpen;
    const onOpen = disclosure.onOpen;
    const onClose = externalOnClose ?? disclosure.onClose;
    const [refundType, setRefundType] = useState("partial");
    const [refundValue, setRefundValue] = useState<number>(0);
    const [inputValue, setInputValue] = useState<string | number>(0);
    const [openModal, setOpenModal] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [openResponseModal, setOpenResponseModal] = useState<boolean>(false)
    const [responseModal, setResponseModal] = useState<boolean>(false)
    const {verifyRefundBalance} = useRefund();

    const responseVerifyData = responseVerifyProp?.[0];
    const maxAmountRefund = responseVerifyData?.value ?? 0;

    useEffect(() => {
        verifyRefundBalance(charge.uuid);
    }, [charge.uuid]);
    
    const handleRefundChange = (value) => {
        setRefundType(value);
        if (value === "total") {
            setRefundValue(maxAmountRefund || 0    );
            setInputValue(maxAmountRefund || 0    );
            setIsValid(true);
        } else {
            setRefundValue(0);
            setInputValue("");
            setIsValid(false);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
              
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d)(\d{2})$/, "$1,$2");
        value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
        
        const numericValue = Number(value.replaceAll(".", "").replace(",", "."));
        setIsValid(numericValue > 0 && numericValue <= maxAmountRefund);

        setInputValue(value);
        
        if(refundType === "partial") {
            setRefundValue(numericValue || 0);
        }
    };

    const handleBlur = () => {
        const maxValue =maxAmountRefund || 0;
        const numericValue = Number(refundValue);

        if (numericValue > maxValue) {
            setInputValue(Number(maxValue.toFixed(2)));
            setIsValid(true);
        }
    };

    useEffect(() => {
        if(refundType === "partial") {
            const value = String(inputValue).replaceAll(".", "").replace(",", ".")
            const numericValue = Number(value);

            if(numericValue){
                setIsValid(numericValue > 0 && numericValue <= maxAmountRefund);
                setRefundValue(numericValue);
            } else {
                setRefundValue(0);
            }
        }
    },[inputValue, refundType])

    useEffect(() => {
        if(refundType === "total") {
            setRefundValue(maxAmountRefund || 0);
            setInputValue(maxAmountRefund || 0);
            setIsValid(true);
        }
    }, [refundType, maxAmountRefund])

    useEffect(() => {
        if(isOpen && refundType === "total" && maxAmountRefund > 0) {
            setRefundValue(maxAmountRefund);
            setInputValue(maxAmountRefund);
            setIsValid(true);
        }
    }, [isOpen, maxAmountRefund, refundType])
    
    return (
        <>

            {externalIsOpen === undefined && (
                <Flex w="154px" flexDir="column" align="flex-start">
                    <Button
                        onClick={onOpen}
                        id="excluir_cobrança"
                        disabled={isDisabled}
                        variant="outline"
                    >
                        Estornar cobrança
                    </Button>
                </Flex>
            )}
            <ConfirmeModal
                amount={refundValue}
                openModal={openModal}
                setOpenModal={setOpenModal}
                setResponseModal={setResponseModal}
                setOpenResponseModal={setOpenResponseModal}             
                setReload={setReload}
                onRefundSuccess={onRefundSuccess}
            />
            <ResponseModal
                openResponseModal={openResponseModal}
                setOpenResponseModal={setOpenResponseModal}
                responseModal={responseModal}
                setReload={setReload}
            />

            <Modal
                isOpen={isOpen}
                title="Como você deseja realizar esse estorno?"
                onClose={onClose}
                footer={{
                    primaryButton: {
                        children: "Continuar",
                        disabled: !isValid,
                        variant: "fill",
                        onClick: () => { setOpenModal(true); onClose(); },
                    },
                    secondaryButton: {
                        children: "Cancelar",
                        variant: "outline",
                        onClick: onClose,
                    },
                }}
            >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", marginBottom: "8px" }}>
                    <Image src="/images/icons/questionRefound.svg" w="20px" h="20px" />
                </div>
                <RadioGroup onChange={handleRefundChange} value={refundType}>
                    <Stack direction="row" gap="0" mt={3}>
                        <Flex p="5px 16px" w="236px" h="40px" cursor="pointer" color={refundType === "partial" ? "#DF295D" : " black"} border={refundType === "partial" ? "1px solid #DF295D" : "1px solid #BEBEBE"} onClick={() => { setRefundType("partial"); setRefundValue(0); setInputValue(""); setIsValid(false) }}>
                            <Radio colorScheme="pink" value="partial">Parcial</Radio>
                        </Flex>
                        <Flex ml="0" w="236px" h="40px" p="5px 16px" cursor="pointer" color={refundType === "total" ? "#DF295D" : " black"} onClick={() => { setRefundType("total"); setRefundValue(maxAmountRefund); setIsValid(true) }} border={refundType === "total" ? "1px solid #DF295D" : "1px solid #BEBEBE"}>
                            <Radio colorScheme="pink" value="total">Total</Radio>
                        </Flex>
                    </Stack>
                </RadioGroup>
                <Text m="25px 0">Digite o valor do estorno que deseja realizar.</Text>
                {refundType === "partial" ? (
                    <Flex flexDirection="column">
                        <Flex flexDirection="column">
                            <Text>Valor do estorno</Text>
                            <Box position="relative" w="240px">
                                <InputCurrency name="refundValue" placeholder="0,00" value={inputValue} onBlur={handleBlur} onChange={handleInputChange} className="refund-input" />
                            </Box>
                            <Text fontSize="sm" color="gray.500" mt={1}>Valor disponível para estorno <b>R$ {maxAmountRefund?.toFixed(2)}</b></Text>
                        </Flex>
                    </Flex>
                ) : (
                    <Text>Será estornado o valor de <b>R$ {maxAmountRefund?.toFixed(2)}</b> correspondente a todo o valor disponível para estorno.</Text>
                )}
            </Modal>
        </>
    );
};

